import { render, staticRenderFns } from "./suggestionsListHighDemandAdder.vue.html?vue&type=template&id=738617dd&"
import script from "./suggestionsListHighDemandAdder.ts?vue&type=script&lang=ts&"
export * from "./suggestionsListHighDemandAdder.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports